const ADMIN_KEY_STORAGE_KEY = 'statspyderAdminKey';

export const ADMIN_KEY_HEADER = 'X-STATSPYDER-ADMIN-KEY';

export const getAdminKeyFromUrl = () => {
    if (typeof window === 'undefined' || !window.location?.search) return '';
    return new URLSearchParams(window.location.search).get('admin_key') || '';
};

export const getStoredAdminKey = () => {
    if (typeof window === 'undefined') return '';
    return window.localStorage.getItem(ADMIN_KEY_STORAGE_KEY) || '';
};

export const setStoredAdminKey = (adminKey) => {
    if (typeof window === 'undefined') return;
    const normalizedKey = String(adminKey || '').trim();
    if (normalizedKey) {
        window.localStorage.setItem(ADMIN_KEY_STORAGE_KEY, normalizedKey);
    } else {
        window.localStorage.removeItem(ADMIN_KEY_STORAGE_KEY);
    }
};

export const getAdminKey = () => {
    const fromUrl = getAdminKeyFromUrl();
    if (fromUrl) return fromUrl;

    const fromStorage = getStoredAdminKey();
    if (fromStorage) return fromStorage;

    if (process.env.REACT_APP_STATSPYDER_ADMIN_KEY) {
        return process.env.REACT_APP_STATSPYDER_ADMIN_KEY;
    }

    return process.env.NODE_ENV === 'development' ? 'test' : '';
};

export const getAdminHeaders = (adminKeyOverride = '') => {
    const adminKey = String(adminKeyOverride || getAdminKey()).trim();
    return {
        'Content-Type': 'application/json',
        ...(adminKey ? { [ADMIN_KEY_HEADER]: adminKey } : {})
    };
};
